import type { FetchData } from '../types'

type FetchAllDataParameters<T> = {
  readonly from: number
  readonly to: number
  readonly limit: number
  readonly desc: boolean
  readonly fetchData: FetchData<T>
}

export const fetchDataWithAutoRetry = async <T>(
  { from, to, limit, desc, fetchData }: FetchAllDataParameters<T>,
  repeat = 0,
): Promise<readonly T[]> => {
  try {
    return await fetchData({ from, to, limit, desc })
  } catch (error) {
    if (repeat < 5 && error instanceof Error) {
      if (error.message.includes('Status: 404')) {
        return []
      }
      if (error.message.includes('Status: 429')) {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        return fetchDataWithAutoRetry(
          { from, to, limit, desc, fetchData },
          repeat + 1,
        )
      }
      if (
        error.message.includes('Status: 500') ||
        error.message.includes('Status: 502') ||
        error.message.includes('Status: 503') ||
        error.message.includes('Status: 504')
      ) {
        await new Promise((resolve) => setTimeout(resolve, 5000))
        return fetchDataWithAutoRetry(
          { from, to, limit, desc, fetchData },
          repeat + 1,
        )
      }
    }
    throw error
  }
}
